/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Has_ChildrenInputs */

const en_filter_has_children = /** @type {(inputs: Filter_Has_ChildrenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`child items`)
};

const de_filter_has_children = /** @type {(inputs: Filter_Has_ChildrenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untergeordnete Vorgänge`)
};

/**
* | output |
* | --- |
* | "child items" |
*
* @param {Filter_Has_ChildrenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_has_children = /** @type {((inputs?: Filter_Has_ChildrenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Has_ChildrenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_has_children(inputs)
	return en_filter_has_children(inputs)
});